import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

export interface ISegmentedControlOption<T extends string> {
  value: T;
  label: string;
}

interface ISegmentedControlProps<T extends string> {
  value: T;
  options: ISegmentedControlOption<T>[];
  onChange: (value: T) => void;
  className?: ClassValue;
  'aria-label'?: string;
}

export default function SegmentedControl<T extends string>({
  value,
  options,
  onChange,
  className,
  'aria-label': ariaLabel,
}: ISegmentedControlProps<T>) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className={cn('flex gap-2', className)}
    >
      {options.map((option) => {
        const isActive = option.value === value;

        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={cn(
              'h-10 flex-1 rounded-lg px-3 text-sm font-medium transition-colors outline-none',
              'focus-visible:ring-2 focus-visible:ring-green-500/50',
              isActive
                ? 'text-white-0 bg-green-600 dark:bg-green-500'
                : 'bg-surface-input text-text-secondary hover:text-text-primary',
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
